export const HANWHA_ORG_ID: number = Number(import.meta.env.VITE_HANWHA_ORG_ID)
